import { Injectable } from '@angular/core';
import {
  getValue,
  isDefined,
  isDefinedAndFilledArray,
} from '../../../../shared/utility/verify.lib';
import { IDocumentTypeText } from '../../../../models/document/document-type-text.model';
import { IDocumentType } from '../../../../models/document/document-type.model';
import { cloneDeep } from 'lodash';
import { IDocumentSession } from '../../../../models/session/document-session.model';

@Injectable({
  providedIn: 'root',
})
export class DocumentTypeHelperService {
  constructor() {}

  public checkIfProduced(session: IDocumentSession): boolean {
    let returnValue: boolean = false;

    if (isDefined(() => session.type) && isDefined(() => session.produced)) {
      returnValue = session.type === 'O' && session.produced;
    }

    return returnValue;
  }

  public updateActiveLanguageTextForDocumentType(
    availableDocumentTypes: IDocumentType[],
    activeLanguage: string
  ): Record<string, string> {
    const documentTextInActiveLanguage: Record<string, string> = {};

    if (isDefinedAndFilledArray(() => availableDocumentTypes)) {
      availableDocumentTypes.forEach((docType: IDocumentType) => {
        if (isDefinedAndFilledArray(() => docType.text)) {
          const docTypeId: string = getValue(() => docType.docTypeId);
          const foundLanguageText: IDocumentTypeText = docType.text.find(
            (docText: IDocumentTypeText) =>
              getValue(() => docText.language) === activeLanguage &&
              isDefined(() => docText.text)
          );
          const defaultLanguageText: IDocumentTypeText = docType.text.find(
            (itemName: IDocumentTypeText) =>
              getValue(() => itemName.language) === 'EN'
          );
          documentTextInActiveLanguage[docTypeId] = isDefined(
            () => foundLanguageText.text
          )
            ? foundLanguageText.text
            : getValue(() => defaultLanguageText.text, null);
        }
      });
    }

    return documentTextInActiveLanguage;
  }

  public updateDocumentTypesAvailableAfterProduction(
    availableDocumentTypes: IDocumentType[],
    orderedDocumentTypes: IDocumentType[],
    isAlreadyProduced: boolean
  ): Record<string, boolean> {
    const isDocumentTypeAvailable: Record<string, boolean> = {};

    if (
      isDefinedAndFilledArray(() => availableDocumentTypes) &&
      isDefinedAndFilledArray(() => orderedDocumentTypes)
    ) {
      const allAvailableTypeIds: string[] = availableDocumentTypes.map(
        (availableType: IDocumentType) =>
          getValue(() => availableType.docTypeId, null)
      );
      orderedDocumentTypes.forEach((orderedType: IDocumentType) => {
        const typeId: string = getValue(() => orderedType.docTypeId, null);
        isDocumentTypeAvailable[typeId] = this.isOnlyAvailableAfterProduction(
          typeId,
          allAvailableTypeIds,
          orderedType,
          isAlreadyProduced
        );
      });
    }

    return isDocumentTypeAvailable;
  }

  public getCheckboxesForDocuments(
    documentTypeOrder: IDocumentType[]
  ): IDocumentType[] {
    let documentTypes: IDocumentType[] = cloneDeep(documentTypeOrder);

    if (isDefinedAndFilledArray(() => documentTypes)) {
      documentTypes = documentTypes.sort((a, b) => a.typeOrder - b.typeOrder);
      const firstSixt = documentTypes.splice(
        documentTypes.length - 6,
        documentTypes.length - 1
      );
      documentTypes = documentTypes.sort((a, b) =>
        a.text[0].text.localeCompare(b.text[0].text)
      );
      documentTypes = [...firstSixt, ...documentTypes];
    }

    return documentTypes;
  }

  private isOnlyAvailableAfterProduction(
    typeId: string,
    allAvailableTypeIds: string[],
    typeToCheck: IDocumentType,
    isAlreadyProduced: boolean
  ): boolean {
    let returnValue: boolean = false;

    if (
      !isAlreadyProduced &&
      isDefined(() => typeId) &&
      allAvailableTypeIds.includes(typeId) &&
      getValue(() => typeToCheck.availabelAfterProduction, false)
    ) {
      returnValue = true;
    }

    return returnValue;
  }
}
